
const routers = [
    { path: 'carrinho', name: 'Carrinho', component: function (resolve) { require(['@/views/carrinho'], resolve) } },
];

export default routers